export default {
    methods: {
        removeSpacesOnPaste(event, value) {
            // event - ClipBoardEvent
            if (!event || !event.clipboardData) {
                return;
            }
            event.preventDefault();

            let pasteText = event.clipboardData.getData('text').replace(/\s/g, '');
            const input = event.target;
            const start = input.selectionStart;
            const end = input.selectionEnd;

            input.value = input.value.slice(0, start) + pasteText + input.value.slice(end);
            input.setSelectionRange(start + pasteText.length, start + pasteText.length);
            event.target.dispatchEvent(new Event('input'));
        },
    },
}



// WEBPACK FOOTER //
// ./resources/js/mixins/helper.js